/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseDictStrBoolDataAnyOf } from './genericApiResponseDictStrBoolDataAnyOf';

export type GenericApiResponseDictStrBoolData = GenericApiResponseDictStrBoolDataAnyOf | null;
